import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const MemberFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const membershipStatusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'frozen', label: 'Frozen' },
    { value: 'expired', label: 'Expired' },
    { value: 'trial', label: 'Trial' }
  ];

  const paymentStatusOptions = [
    { value: 'all', label: 'All Payments' },
    { value: 'paid', label: 'Paid' },
    { value: 'pending', label: 'Pending' },
    { value: 'overdue', label: 'Overdue' },
    { value: 'failed', label: 'Failed' }
  ];

  const membershipTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'annual', label: 'Annual' },
    { value: 'class-based', label: 'Class-Based' },
    { value: 'family', label: 'Family' },
    { value: 'corporate', label: 'Corporate' }
  ];

  const lastVisitOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '90days', label: 'Last 90 Days' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Advanced Filters
        </h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearFilters}
          iconName="X"
          iconPosition="left"
        >
          Clear All
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search by name, email, phone..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          placeholder="Membership Status"
          options={membershipStatusOptions}
          value={filters?.membershipStatus}
          onChange={(value) => onFilterChange('membershipStatus', value)}
        />

        <Select
          placeholder="Payment Status"
          options={paymentStatusOptions}
          value={filters?.paymentStatus}
          onChange={(value) => onFilterChange('paymentStatus', value)}
        />

        <Select
          placeholder="Membership Type"
          options={membershipTypeOptions}
          value={filters?.membershipType}
          onChange={(value) => onFilterChange('membershipType', value)}
        />

        <Select
          placeholder="Last Visit"
          options={lastVisitOptions}
          value={filters?.lastVisit}
          onChange={(value) => onFilterChange('lastVisit', value)}
        />

        <Input
          type="number"
          placeholder="Min Age"
          value={filters?.minAge}
          onChange={(e) => onFilterChange('minAge', e?.target?.value)}
        />

        <Input
          type="number"
          placeholder="Max Age"
          value={filters?.maxAge}
          onChange={(e) => onFilterChange('maxAge', e?.target?.value)}
        />

        <Select
          placeholder="Gender"
          options={[
            { value: 'all', label: 'All Genders' },
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' },
            { value: 'other', label: 'Other' }
          ]}
          value={filters?.gender}
          onChange={(value) => onFilterChange('gender', value)}
        />
      </div>
    </div>
  );
};

export default MemberFilters;